module.exports = __webpack_public_path__ + "static/media/shipt-1.90a9410c.jpg";